import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import {withStyles} from 'material-ui/styles';
import MainTheme from '../layout/theme';
import Footer from '../footer';
import styles from './styles';

const Welcome = ({classes, acceptTerms}) => (
	<MainTheme>
		<header className={classes.header}>
			<img src="/assets/logo.svg" alt="Juvora | Guide"/>
		</header>
		<div className={classes.overlay}>
			<Paper
				square
				classes={{
					shadow2: classes.removePaperShadow, // if it's not desktop
					root: classes.content
				}}
			>
				<p className={classes.message}>
					Welcome to the JUVORA&#8482; Guide, your resource for education
					and training on the JUVORA&#8482; dental disc for fixed
					and removable prosthetic applications.
				</p>
				<Button
					raised
					color="accent"
					className={classes.button}
					onClick={acceptTerms}
				>
					{"Let's get started"}
				</Button>
			</Paper>
			<Footer classes={{container: classes.footer}}/>
		</div>
	</MainTheme>
);

Welcome.propTypes = ({
	classes: PropTypes.object.isRequired,
	acceptTerms: PropTypes.func
});

export default withStyles(styles)(Welcome);



// WEBPACK FOOTER //
// ./src/client/components/main/welcome/index.jsx